const PIXEL_ID = '25823921580633383'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

export function initMetaPixel() {
  // Prevent double initialization
  if (document.getElementById('meta-pixel-script')) return

  // Inject the official Meta Pixel inline script
  const inlineScript = document.createElement('script')
  inlineScript.id = 'meta-pixel-script'
  inlineScript.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    if(s){s.parentNode.insertBefore(t,s)}else{b.head.appendChild(t)}
    }(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${PIXEL_ID}');
    fbq('track', 'PageView');
  `
  document.head.insertBefore(inlineScript, document.head.firstChild)

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" />`
  document.body.appendChild(noscript)
}

export function trackViewContent(contentName?: string) {
  if (window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: contentName || 'Protocolo Maestro - Oferta',
      content_type: 'product',
      value: 12,
      currency: 'USD',
    })
  }
}

export function trackLead() {
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'Protocolo Maestro',
      value: 12,
      currency: 'USD',
    })
  }
}

export function trackInitiateCheckout() {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Protocolo Maestro',
      value: 12,
      currency: 'USD',
      num_items: 1,
    })
  }
}
